// Mood Board Color
export const BG_PRIMARY = '#ceac7e';
export const BG_SECONDARY = '#fff8ee';
export const BG_ALTERNATIVE = '#8E80B8';

// Text Color
export const TEXT_PRIMARY = '#bf8f82';
export const TEXT_SECONDARY = '#8d7e70';
export const TEXT_ALTERNATIVE = '#ceac7e';

// Music & Navigation Color
export const NAVIGATION_COLOR = '#bf8f82'; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya
// Drawer Color
export const DRAWER_COLOR = 'rgb(255 248 241 / 100%)';

// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
